import type { MapId } from "@69ly/maps";

// CS2's own map icons and loading screenshots (packages/ui/assets/maps), as hashed asset URLs.
const files = import.meta.glob("../../../../packages/ui/assets/maps/*.webp", {
  eager: true,
  query: "?url",
  import: "default",
}) as Record<string, string>;

const find = (name: string) => Object.entries(files).find(([path]) => path.endsWith(`/${name}`))?.[1] ?? "";

/** The map's badge, as on CS2's map vote. */
export const mapIconUrl = (map: MapId) => find(`${map}-icon.webp`);
/** A view of the map, as on CS2's loading screen. */
export const mapShotUrl = (map: MapId) => find(`${map}-shot.webp`);
